<template>
    <div class="row">
        <div class="col-sm-12">
            <table-data
                :title="pageTitle"
                :route="url"
                :expandFilters="table.expandFilters"
                :settings="table.settings"
                :columns="table.columns"
                :inlineFilters="table.filters"
                :autoUpdateFilter="table.autoUpdateFilter"
                :addParamsToUrl="table.addParamsToUrl"
                :loadingMsg="table.loadingMsg"
                :notFoundMsg="table.notFoundMsg"
                :orderByTemplate="table.orderByTemplate"
                @error-load="showError"
                tableClass="table-responsive-sm"
            >
                <template v-slot:filters-body="{ tableFilters }">
                    <div class="row">
                        <div class="col-12 col-sm-3" v-show="showModules">
                            <MaterialSelect
                                class="city-form-group city-bg"
                                id="input-module"
                                name="module"
                                label="name"
                                :options="modules"
                                v-model.trim="tableFilters.module"
                                v-validate="''"
                                :inputClasses="[{'is-invalid': fnHasError('module')}]"
                                :error="fnFirstError('module')">
                                {{ $t(`${pageID}.search.module`) }}
                            </MaterialSelect>
                        </div>
                        <div class="col-12 col-sm-3">
                            <MaterialSelect
                                class="city-form-group city-bg"
                                id="input-channel"
                                name="channel"
                                label="name"
                                :options="channels"
                                v-model.trim="tableFilters.channel"
                                v-validate="''"
                                :inputClasses="[{'is-invalid': fnHasError('channel')}]"
                                :error="fnFirstError('channel')">
                                {{ $t(`${pageID}.search.channel`) }}
                            </MaterialSelect>
                        </div>
                        <div class="col-12" :class="[showModules ? 'col-sm-6' : 'col-sm-9']">
                            <MaterialDateRangePicker
                                class="city-form-group city-bg"
                                id="input-created_at"
                                name="created_at"
                                v-model.trim="tableFilters.created_at"
                                :dateFormat="labelDateFormat"
                                :clearButton="true"
                                :showTime="false"
                                :singleDatePicker="false"
                                :showDropdowns="true">
                                {{ $t(`${pageID}.search.created_at`) }}
                            </MaterialDateRangePicker>
                        </div>
                        <div class="col-12 col-sm-5">
                            <MaterialInput
                                type="text"
                                class="city-form-group city-bg"
                                id="input-recipients"
                                name="recipients"
                                v-model.trim="tableFilters.recipients"
                                v-validate="'min:3'"
                                :inputClasses="[{'is-invalid': fnHasError('recipients')}]"
                                :error="fnFirstError('recipients')">
                                {{ $t(`${pageID}.search.recipients`) }}
                            </MaterialInput>
                        </div>
                        <div class="col-12 col-sm-7">
                            <MaterialInput
                                type="text"
                                class="city-form-group city-bg"
                                id="input-content"
                                name="content"
                                v-model.trim="tableFilters.content"
                                v-validate="'min:3'"
                                :inputClasses="[{'is-invalid': fnHasError('content')}]"
                                :error="fnFirstError('content')">
                                {{ $t(`${pageID}.search.content`) }}
                            </MaterialInput>
                        </div>
                    </div>
                </template>
                <template v-slot:body="{row, index}">
                    <td :class="table.columns[0].class" v-html="columnValue(row, table.columns[0])"></td>
                    <td :class="table.columns[1].class" v-html="columnValue(row, table.columns[1])"></td>
                    <td :class="table.columns[2].class">
                        {{ columnValue(row, table.columns[2]) }}
                    </td>
                    <td :class="table.columns[3].class">
                        {{ columnValue(row, table.columns[3]) }}
                    </td>
                    <column-actions v-if="checkActions"
                        :routeEdit="routeEdit"
                        :canDetail="canDetail"
                        :canEdit="false"
                        :canDelete="false"
                        :row="row"
                        :index="index" />
                </template>
            </table-data>
        </div>
    </div>
</template>

<script>
import NotificationHistoryMixin from '../mixins/NotificationHistoryMixin'

export default {
    mixins: [
        NotificationHistoryMixin
    ],
    props: {
        url: {
            type: String,
            require: true,
        },
        routeEdit: {
            type: String,
            required: false,
        },
        modules: {
            type: Array,
            default: () => [],
        },
        channels: {
            type: Array,
            default: () => [],
        },
        globalFilters: {
            type: Object,
            default: () => {},
        }
    },
    data() {
        let pageID = this.panelId;
        return {
            pageID: pageID,
            table: {
                addParamsToUrl: true,
                expandFilters: true,
                settings: {
                    order_by: 'created_at',
                    sort: 'desc',
                },
                filters: {
                    module:  null,
                    channel: null,
                    recipients: null,
                    content: null,
                    created_at: {
                        startDate: null,
                        endDate: null
                    },
                },
                columns: [
                    {
                        label: `${pageID}.list.channel`,
                        field: 'channel',
                        sortable: true,
                        class: "w-50px text-center",
                        func: (val) => val ? this.getIcon(val) : null,
                    },
                    // {
                    //     label: `${pageID}.list.module`,
                    //     field: 'module',
                    //     sortable: true,
                    //     class: "text-center",
                    // },
                    {
                        label: `${pageID}.list.to`,
                        field: 'data.recipients',
                        sortable: true,
                        func: (val, obj) => this.getRecipients(val, obj),
                    },
                    {
                        label: `${pageID}.list.subject`,
                        field: 'data.subject',
                        sortable: true,
                        class: "text-truncate",
                    },
                    // {
                    //     label: `${pageID}.list.message`,
                    //     field: 'data.content',
                    //     sortable: false,
                    //     class: "text-truncate",
                    //     func: (val) => val.replace(/<[^>]+>/g, '')
                    // },
                    {
                        label: `${pageID}.list.created_at`,
                        field: 'created_at',
                        sortable: true,
                        class: "w-200px text-center",
                        func: (val) => val ? moment(val).format('DD/MM/YYYY HH:mm') : null,
                    },
                    {
                        label: '',
                        field:  null,
                        sortable: false,
                        class: 'actions small',
                    }
                ],
            },
        }
    },
    computed: {
        showModules() {
            return this.modules.length > 1;
        },
    },
    methods: {
        getRecipients(val, obj) {
            let channel = obj?.channel?.toLowerCase() ?? null;
            let name = obj?.data?.name ?? '';// ?? obj?.notifiable?.name;
            if(name) {
                name = `<p class='mb-0'>${name}</p>`;
            }
            let contact = val ?? (channel == 'mail' ? obj?.notifiable?.email : (channel == 'sms' ? obj?.notifiable?.phone : null));
            contact = contact ? `<p class='mb-0 small'>(${contact})</p>` : '';
            return name + contact;
        },
    }
}
</script>
